module.exports = __webpack_public_path__ + "img/雷俊峰副教授.211570a6.jpg";